<template>
  <div>
    <v-row dense class="mb-1">
      <v-col cols="12" sm="8">
        <span class="text--primary font-weight-bold ml-3">
          Documentos ativos
        </span>
      </v-col>
      <v-col cols="12" sm="4" align="end">
        <px-fornecedor-adicionar-documento :fornecedor="fornecedor" @update="onUpdate">
          <template v-slot:activator="{ on }">
            <v-btn v-if="hasRoleComprador"
                  small
                  v-on="on"
                  color="primary"
                  class="normal-btn-text rounded-tag-small elevation-0">
              <v-icon small>mdi-plus</v-icon>
                Documento
            </v-btn>
            </template>
          </px-fornecedor-adicionar-documento>
      </v-col>
    </v-row>
    <v-card outlined class="rounded-card">
      <px-lista-documentos :has-role-comprador="hasRoleComprador"
                          :documentos="documentos"
                          :fornecedor="fornecedor"
                          :loading="loading"/>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FornecedorAdicionarDocumento from '../components/FornecedorAdicionarDocumento.vue';
import DocumentoService from '../../gestao-fornecedor-service';
import ListaDocumentos from '../components/listas/ListaDocumentos.vue';

export default {
  props: {
    fornecedor: Object,
  },
  data() {
    return {
      loading: false,
      documentos: {
        content: [],
        total: 0,
      },
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
    getDocumentos() {
      this.loading = true;
      DocumentoService.getDocumentos(this.fornecedor.id)
        .then((response) => {
          this.documentos = response.data || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getDocumentos();
  },
  components: {
    pxFornecedorAdicionarDocumento: FornecedorAdicionarDocumento,
    pxListaDocumentos: ListaDocumentos,
  },
};
</script>
